import { snapMovementDelta } from './annotationGroupOperations';

const APPLE_PLATFORM_PATTERN = /Mac|iPhone|iPad/;

export const isPrimaryBlockPointerAction = ({
  button,
  ctrlKey = false,
  platform = '',
}) => (
  (button === undefined || button === 0) &&
  !(ctrlKey && APPLE_PLATFORM_PATTERN.test(platform))
);

export const shouldHandleBlockClick = ({ suppressSecondaryClick = false, ...pointer }) => (
  !suppressSecondaryClick && isPrimaryBlockPointerAction(pointer)
);

export const canOpenAnnotationForm = ({ isTrackEditMode = false }) => !isTrackEditMode;

export const canSelectAnnotationBlock = ({ isTrackEditMode = false }) => !isTrackEditMode;

export const getAnnotationBlockInteraction = ({
  toolMode,
  isSelected,
  isViewMode,
  isResizing,
  disabled = false,
}) => {
  if (disabled || isViewMode || isResizing) return 'none';
  if (toolMode === 'cursor') return isSelected ? 'group-drag' : 'marquee';
  return 'single-drag';
};

export const planPointerDrag = ({
  originClientX,
  clientX,
  originX,
  movementStep,
  clampX = value => value,
}) => {
  const clampedX = clampX(originX + clientX - originClientX);
  const rawDelta = clampedX - originX;
  const snappedDelta = snapMovementDelta(rawDelta, movementStep);
  return { rawDelta, snappedDelta, x: originX + snappedDelta };
};
